import { DashboardWidget } from './dashboard-widget';
import { DateRange } from './dashboard-filter';
import { html, PropertyValues } from 'lit';
import { moneyToCompactStr } from '../../../../webmodule-common/other/currency-formatter';
import { property } from 'lit/decorators.js';
import { serverDateTimeToLocalDateTime } from '../../../../webmodule-common/other/datetime-converter';
import { Snippet } from '../../../../webmodule-common/interop/webmodule-interop';
import { TimelineWidgetModal } from './timeline-widget-modal';

export const ApexCharts = (globalThis as any).ApexCharts;

export abstract class ApexChartWidget extends DashboardWidget {
  chart: any | null = null;

  @property({ type: Object }) dateRange?: DateRange;

  private chartElementClass: string = '';

  constructor(chartElementClass: string) {
    super();

    this.chartElementClass = chartElementClass;
  }

  protected firstUpdated(): void {
    const options = {
      chart: {
        type: 'area',
        height: '100%',
        selection: {
          enabled: false
        },
        stacked: false,
        toolbar: {
          tools: {
            download: false,
            customIcons: [
              {
                icon: '<i class="fa fa-plus-circle fa-lg"></i>',
                index: 0,
                title: 'Zoom',
                class: 'custom-icon',
                click: (chart: any, options: any, e: any) => this.onChartClick(e, chart, options)
              }
            ]
          }
        },
        zoom: {
          enabled: false
        }
      },
      stroke: {
        width: 1
      },
      dataLabels: {
        enabled: false
      },
      legend: { show: false },
      tooltip: {
        enabled: false
      },
      states: {
        hover: {
          filter: {
            type: 'none',
            value: 0
          }
        },
        active: {
          filter: {
            type: 'none',
            value: 0
          }
        }
      },
      series: [],
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        labels: {
          formatter: (value: number) => this.getYAxisLabel(value)
        }
      },
      noData: {
        text: 'Loading...'
      }
    };

    this.chart = new ApexCharts(this.querySelector(`.${this.chartElementClass}`), options);
    this.chart?.render();
  }

  protected updated(changedProperties: PropertyValues) {
    super.updated(changedProperties);
    this.updateData();
  }

  protected abstract getTitle(): string;

  protected getHeader(): Snippet {
    return this.getTitle();
  }

  protected getBody(): Snippet {
    return html`<div class="${this.chartElementClass}"></div>`;
  }

  protected getYAxisLabel(value: number): string {
    return `$${moneyToCompactStr(value)}`;
  }

  protected async onChartClick(_event: any, _chartContext: any, config: any) {
    const modal = new TimelineWidgetModal(this.getTitle(), config.config.series, this.getCategoryLabels());
    await modal.showModal();
  }

  protected getCategoryLabels(): string[] {
    const labels: string[] = [];
    if (this.dateRange) {
      for (
        let currentDate = new Date(this.dateRange.startDate);
        currentDate <= this.dateRange.endDate;
        currentDate.setDate(currentDate.getDate() + 1)
      ) {
        labels.push(currentDate.toDateString());
      }
    }
    return labels;
  }

  protected convertDateToMillis(dateStr: string): number {
    let dt = serverDateTimeToLocalDateTime(dateStr);
    dt = dt.set({ hour: 0, minute: 0 });
    return dt.toMillis();
  }

  protected abstract updateData(): void;
}
